import { render, staticRenderFns } from "./UpdateInventoryModal.vue?vue&type=template&id=6431d424&"
import script from "./UpdateInventoryModal.vue?vue&type=script&lang=js&"
export * from "./UpdateInventoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports